import { BasicInfoBox } from './VehicleCard';
import {
  InfoBoxTitle,
  InfoBoxValue,
  InfoBoxValueContainer,
  InfoBoxValuesContainer,
  VehicleInfoBoxContainer,
} from './VehicleCard.styles';

export interface ShimmerBox extends BasicInfoBox {
  shimmerValue: JSX.Element;
}

const VehicleShimmerBox = ({ data }: { data: ShimmerBox }) => {
  return (
    <VehicleInfoBoxContainer>
      <InfoBoxTitle>{data.title}</InfoBoxTitle>
      <InfoBoxValuesContainer>
        <InfoBoxValueContainer>
          <InfoBoxValue>{data.shimmerValue}</InfoBoxValue>
        </InfoBoxValueContainer>
      </InfoBoxValuesContainer>
    </VehicleInfoBoxContainer>
  );
};

export default VehicleShimmerBox;
